const ALERT_COOKIE_NAME = 'information';
const ALERT_COOKIE_VALUE = 'global-website-information';
const ALERT_COOKIE_DAYS = 1;

function getCookie(name) {
    const match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return match ? match[1] : null;
}

function addAlertClasses() {
    document.body?.classList.add('alert');
    document.querySelector('.nav')?.classList.add('alert');
    document.querySelector('.page-header')?.classList.add('alert');
    document.querySelector('.main-content')?.classList.add('alert');
}

function removeAlertClasses() {
    document.body?.classList.remove('alert');
    document.querySelector('.nav')?.classList.remove('alert');
    document.querySelector('.page-header')?.classList.remove('alert');
    document.querySelector('.main-content')?.classList.remove('alert');
}

function setAlertCookie() {
    const now = new Date();
    now.setTime(now.getTime() + ALERT_COOKIE_DAYS * 24 * 3600 * 1000);
    document.cookie = `${ALERT_COOKIE_NAME}=${ALERT_COOKIE_VALUE}; expires=${now.toUTCString()}; path=/`;
}

function initGlobalAlert() {
    const alertBar = document.getElementById('alert__wrapper');
    if (!alertBar) {
        removeAlertClasses();
        return;
    }

    if (getCookie(ALERT_COOKIE_NAME) === null) {
        alertBar.classList.remove('hide');
        addAlertClasses();
    } else {
        alertBar.classList.add('hide');
        removeAlertClasses();
    }

    const close = alertBar.querySelector('.alert__close');
    if (close && close.dataset.alertBound !== '1') {
        close.addEventListener('click', () => {
            alertBar.classList.add('hide');
            removeAlertClasses();
            setAlertCookie();
        });
        close.dataset.alertBound = '1';
    }
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGlobalAlert, { once: true });
} else {
    initGlobalAlert();
}

if (window.htmx?.on) {
    window.htmx.on('htmx:afterSwap', initGlobalAlert);
}
